import { AboutUs } from './AboutUs';
import { StandardHeader } from './StandardHeader';
import './css/App.css';
import { TeamMembers } from './TeamMembers';

function App() {

  return (
    <div className="App h-screen">
      <StandardHeader />
      <AboutUs />
      <TeamMembers />
    </div>
  );
}

export default App;
